import { render } from "./SectionHeader.vue?vue&type=template&id=6d976ec0&scoped=true"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"

import "./SectionHeader.vue?vue&type=style&index=0&id=6d976ec0&scoped=true&lang=css"

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d976ec0"]])

export default __exports__